(function ($) {
  var focusTrap = {
    trap: function($root) {
      this.release();
      this._tabbingContext = Drupal.tabbingManager.constrain($root, {trapFocus: true});
    },
    release: function() {
      if (this._tabbingContext) {
        this._tabbingContext.release();
      }
    },
  };

  // @see _l-header.scss
  Drupal.behaviors.pperThemeStickyHeader = {
    attach: function(context) {
      $(once('pper-theme-sticky-header', 'header.it-header-sticky', context)).each(function() {
        var $header = $(this);

        var setHeight = function() {
          var headerHeight = parseInt($header.height(), 10);
          $('html').css('--pper-header-height', headerHeight + 'px');

          Drupal.webform = Drupal.webform || {};
          Drupal.webform.scrollTopOffset = headerHeight;
        };

        setHeight();
        $(window).resize(setHeight);
      });
    }
  };

  /**
   * Su alcuni screen reader la lettura del messaggio d'errore (o di successo) è possibile
   * solo se i messaggi sono il primo elemento interagibile del DOM.
   * Questo behavior sposta i messaggi proprio all'inizio del body.
   * Una conseguenza di questo è che l'header deve essere posizionato in assoluto, in modo da non visualizzare prima i messaggi e poi l'header.
   * @see _l-header.scss
   */
  Drupal.behaviors.pperThemeA11yDrupalMessages = {
    attach: function(context) {
      $(once('pper-theme-a11y-drupal-message', '[data-drupal-messages] .messages'), context).each(function() {
        $(this).closest('.region').prependTo('body');
        $('[role="alert"]', this).eq(0).attr('tabindex', '0').focus();
      });
    }
  };

  Drupal.behaviors.pperThemeAttachBehaviorsToModals = {
    attach: function() {
      $(once('pper-theme-attach-behaviors-to-modals', 'body')).each(function() {
        $(this).on('shown.bs.modal', function(ev) {
          Drupal.attachBehaviors(ev.target);
        });
      });
    }
  };

  Drupal.behaviors.pperThemeNavTabsScrollToActive = {
    attach: function(context) {
      $(once('pperTheme-nav-tabs-scroll-to-active', '.nav-tabs', context)).each(function(e) {
        var width = $(this).width();
        var scroll = 0;

        $('a', this).each(function() {
          scroll += $(this).outerWidth();

          if ($(this).hasClass('active')) {
            return false;
          }
        });

        if (scroll > width) {
          this.scrollLeft = scroll;
        }
      });
    }
  };

  Drupal.behaviors.pperThemeCarouselCard = {
    attach: function(context) {
      $(once('pperTheme-carousel-card', '.carousel-card', context)).each(function(e) {
        var $content = $(this).find('.carousel-content');
        var $navPrev  = $(this).find('.carousel-prev');
        var $navNext  = $(this).find('.carousel-next');

        $('.carousel-wrapper > *', this).wrap('<div class="swiper-slide"></div>');

        new Swiper($content.get(0), {
          a11y: false,
          loop: false,
          slidesPerView: 1,
          createElements: true,
          navigation: {
            prevEl: $navPrev.get(0),
            nextEl: $navNext.get(0),
          },
          pagination: false,
          breakpoints: {
            576: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            }
          },
        });
      });
    }
  };

  Drupal.behaviors.pperThemeCarouselArticleGallery = {
    attach: function(context) {
      $(once('pperTheme-carousel-article-gallery', 'article .carousel-gallery', context)).each(function(e) {
        var $content = $(this).find('.carousel-content');
        var $navPrev  = $(this).find('.carousel-prev');
        var $navNext  = $(this).find('.carousel-next');

        $('.carousel-wrapper > *', this).wrap('<div class="swiper-slide"></div>');

        new Swiper($content.get(0), {
          a11y: false,
          loop: false,
          slidesPerView: 1,
          spaceBetween: 16,
          createElements: true,
          navigation: {
            prevEl: $navPrev.get(0),
            nextEl: $navNext.get(0),
          },
          pagination: false,
          breakpoints: {
            576: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            }
          },
        });
      });
    }
  };

  Drupal.behaviors.pperThemeGallery = {
    attach: function(context) {
      $(once('pperTheme-gallery', '.gallery', context)).each(function(e) {
        $('a', this).attr('data-lity', '');
      });
    }
  };

  Drupal.behaviors.pperThemeSidebar = {
    attach: function(context) {
      $(once('pperTheme-sidebar', '.attach-sidebar', context)).each(function(e) {
        var sidebarHtml = '<aside class="col-lg-4">\n' +
          '<div id="sidebar" class="sidebar navbar-wrapper">\n' +
          '  <nav class="navbar it-navscroll-wrapper it-top-navscroll">\n' +
          '    <button class="custom-navbar-toggler" type="button" aria-controls="navbarNav" aria-expanded="false" aria-label="Navigazione" data-target="#navbarNav">\n' +
          '      <span class="it-list">\n' +
          '        <svg aria-hidden="true" role="img" class="icon icon-sm icon-primary align-top">\n' +
          '          <use xlink:href="' + drupalSettings.path.baseUrl + 'themes/custom/portaledellafamiglia/dist/vendors/bootstrap-italia/svg/sprite.svg#it-list"></use>\n' +
          '        </svg>\n' +
          '      </span>\n' +
          '      Indice\n' +
          '    </button>\n' +
          '    <div class="navbar-collapsable" id="navbarNav">\n' +
          '      <div class="overlay"></div>\n' +
          '      <div class="close-div sr-only">\n' +
          '        <button class="btn close-menu" type="button">\n' +
          '          <span class="it-close"></span>Chiudi\n' +
          '        </button>\n' +
          '      </div>\n' +
          '      <a class="it-back-button" href="#">\n' +
          '        <svg aria-hidden="true" role="img" class="icon icon-sm icon-primary align-top">\n' +
          '          <use xlink:href="' + drupalSettings.path.baseUrl + 'themes/custom/portaledellafamiglia/dist/vendors/bootstrap-italia/svg/sprite.svg#it-chevron-left"></use>\n' +
          '        </svg>\n' +
          '        <span>Torna indietro</span>\n' +
          '      </a>\n' +
          '      <div class="menu-wrapper">\n' +
          '        <div class="link-list-wrapper menu-link-list">\n' +
          '          <span class="sr-only">Indice</span>\n' +
          '          <ul class="link-list">\n' +
          '          </ul>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>\n' +
          '  </nav>\n' +
          '</div>';

        var $sidebar = $(sidebarHtml);

        var $headings = $(this).find('> article > h2');

        $headings.each(function(i) {
          var $parent = $(this).parent();
          var anchor = 'anchor-' + i;
          var itemHtml = '<li class="nav-item">\n' +
            '  <a class="nav-link" href="#' + anchor + '"><span>' + $.trim($(this).text()) + '</span></a>\n' +
            '</li>'

          $parent.attr('id', anchor);
          $parent.addClass('anchor-offset it-page-section');
          $('.link-list', $sidebar).append(itemHtml);
        });

        if ($headings.length) {
          $sidebar.insertBefore(this);
        }

        $sidebar.find('a[href^="#"]').click(function() {
          var position = $($(this).attr('href')).offset().top;

          $('body, html').animate({
            scrollTop: position,
          });
        })
      });
    }
  };

  Drupal.behaviors.pperThemeSearchModal = {
    attach: function(context) {
      $(once('pperTheme-search-modal', '#search-modal')).each(function() {
        // Sposta la modale come figlio diretto del body, per evitare problemi di visulizzazione.
        $(this).appendTo(document.body);
        $(this).on('shown.bs.modal', function() {
          $('input[name="s"]', this).focus();
        });
      });
    }
  };

  Drupal.behaviors.pperThemeViewsFakeSort = {
    attach: function(context) {
      $(once('pper-theme-views-fake-sort', '.sort-order input[type="radio"]', context)).each(function() {
        var $view = $(this).closest('.view');
        var $sortOrder = $('[name="sort_order"]', $view);
        var isSelected = ($sortOrder.val() === $(this).val());

        $(this).prop('checked', isSelected);

        $(this).change(function() {
          $sortOrder.val($(this).val());
          $('.form-actions .form-submit:eq(0)').click();
        });
      });

      $(once('pper-theme-views-fake-sort', '[name="fake-sort-by"]', context)).each(function() {
        var $view = $(this).closest('.view');
        var $sortBy = $('[name="sort_by"]', $view);
        var $sortOrder = $('[name="sort_order"]', $view);

        $(this).val($sortBy.val());

        // Rimuovi opzioni fake che non hanno un corrispettivo ordinamento nativo.
        $(this).find('option').each(function() {
          if ($sortBy.find('option[value="' + $(this).val() + '"').length === 0) {
            $(this).remove();
          }
        });

        $(this).change(function() {
          var value = $(this).val();

          var $opt = $('option', this).filter(function() {
            return this.value === value;
          });

          $sortBy.val($(this).val());
          $sortOrder.val($opt.attr('data-default-order') || 'ASC');

          $('.form-actions .form-submit:eq(0)').click();
        });

        $(this).click(function() {
          $sortBy.val($(this).attr('data-sort-order'));
        });
      });
    }
  };

  Drupal.behaviors.pperThemeDisableAutoSubmitOnMobile = {
    attach: function(context) {
      $(once('pper-theme-disable-auto-submit-on-mobile', '.view.disable-auto-submit-on-mobile')).each(function() {

        $('[data-bef-auto-submit-exclude]', this).attr('data-force-bef-auto-submit-exclude', '');

        var $root = $('.views-exposed-form', this);
        var notMobileMedia = window.matchMedia('(min-width: 992px)');
        var update = function() {
          $(':input:not(.form-submit)', $root).each(function() {
            if (notMobileMedia.matches && $(this).attr('data-force-bef-auto-submit-exclude') === undefined) {
              $(this).removeAttr('data-bef-auto-submit-exclude');
            }
            else {
              $(this).attr('data-bef-auto-submit-exclude', '');
            }
          });
        };

        update();
        notMobileMedia.addEventListener('change', update);
      });
    }
  };

  Drupal.behaviors.pperThemeTabs = {
    attach: function(context) {
      $(once('pper-theme-tabs', '.nav-tabs .nav-item.active', context)).each(function() {
        $(this).children().addClass('active');
      });
    }
  };

  /**
   * Finché il Cookie Banner è attivo consenti la navigazione da tastiera solo al suo interno.
   */
  Drupal.behaviors.pperThemeA11yCookieBanner = {
    attach: function(context) {
      $(once('pper-theme-a11y-cb', 'body')).each(function() {
        $(document.body).on('eu_cookie_compliance_popup_open', function(ev) {
          focusTrap.trap($(ev.target))
        });

        $(document.body).on('eu_cookie_compliance_popup_close', function() {
          focusTrap.release();
        });
      });
    }
  };

  Drupal.behaviors.pperThemeA11yRating = {
    attach: function(context) {
      $(once('pper-theme-a11y-rating', '.br-widget'), context).each(function() {
        if ($(this).is('.br-readonly')) {
          var lastRatingText = $('a.br-selected:last', this).attr('data-rating-text');
          var avgRating = 'Nessuna valutazione';

          if (lastRatingText) {
            avgRating = 'Valutazione media: ' + lastRatingText;
          }

          $(this).attr('title', avgRating);

          $('a', this).attr('aria-disabled', 'true');
        }
        else {
          $('.br-current-rating', this)
            .addClass('d-block visually-hidden');

          $('a', this).each(function() {
            $(this)
            .css('cursor', 'pointer')
            .attr('role', 'button')
            .removeAttr('href')
            .attr('tabindex', '0')
            .attr('aria-label', 'Valuta come: ' + $(this).attr('data-rating-text'))
            .on('keypress', function(e) {
              const keyD = e.key !== undefined ? e.key : e.keyCode;

              if ( (keyD === 'Enter' || keyD === 13) || (['Spacebar', ' '].indexOf(keyD) >= 0 || keyD === 32)) {
                e.preventDefault();
                this.click();
              }
            })
            .on('keyup', function(e) {
              if (e.key === 'ArrowRight') {
                $(this).next().addBack().focus();
              }
              else if (e.key === 'ArrowLeft') {
                $(this).prev().focus();
              }
            });
          });
        }
      });
    }
  };

  Drupal.behaviors.pperThemeA11yLity = {
    attach: function() {
      $(once('pper-theme-a11y-lity', 'body')).each(function() {
        $(document.body).on('lity:open', function() {
          $('.lity-loader').text('In caricamento...');
          $('[data-lity-close]').attr('aria-label',  'Chiudi (puoi anche premere il tasto ESC)').focus();
        });
      });
    }
  };

  Drupal.behaviors.pperThemeA11yLeaflet = {
    attach: function() {
      $(once('pper-theme-a11y-leaflet', 'body')).each(function() {
        var makeLeafletElementsUnreachable = function() {
          $('.leaflet-container, .leaflet-container a, .leaflet-marker-icon').attr('tabindex', -1);
        };

        $(document).on('secondo-livello-map:loaded', makeLeafletElementsUnreachable);
        $(document).on('secondo-livello-map:layeradd', makeLeafletElementsUnreachable);

        // Siccome è complicato agganciarsi alla mappa una volta che tutto è stato creato e inserito (zoom, marker, ecc)
        // è più facile eseguire la logica dopo un tempo ragionevolmente sufficiente, all'interno del quale la mappa sicuramente sarà pronta.
        setTimeout(makeLeafletElementsUnreachable, 1000);
      });
    }
  };

  Drupal.behaviors.pperThemeA11yModals = {
    attach: function() {
      $(once('pper-theme-a11y-modals', '[data-toggle="modal"]')).each(function() {
        var $button = $(this);
        var $target = $($(this).attr('data-target'));

        var update = function () {
          $button.attr('aria-expanded', $target.is('.show') ? 'true' : 'false');
        };

        update();
        $target.on('shown.bs.modal', update);
        $target.on('hidden.bs.modal', update);
      });
    }
  };

  Drupal.behaviors.pperThemeA11yTabs = {
    attach: function() {
      $(once('pper-theme-a11y-tabs', '.nav-tabs')).each(function() {
        function update($root) {
          $('a[href]', $root).each(function() {
            if ($(this).is('.active')) {
              $(this).attr('aria-current', 'page');
            }
            else {
              $(this).removeAttr('aria-current');
            }
          })
        }

        update(this);

        $(this).on('shown.bs.tab hidden.bs.tab', function(ev) {
          update($(this).closest('.nav-tabs'));
        });
      });
    }
  };

  Drupal.behaviors.pperThemeA11yModalsFocusTrap = {
    attach: function() {
      $(once('pper-theme-a11y-modals-focus-trap', 'body')).each(function() {
        $(this).on('shown.bs.modal', function(ev) {
          focusTrap.trap($(ev.target));
        });

        $(this).on('hidden.bs.modal', function(ev) {
          focusTrap.release();
        });
      });
    }
  };

  Drupal.behaviors.pperThemeA11yDrupalManagedFileUpload = {
    attach: function() {
      $(once('pper-theme-a11y-drupal-managed-file-upload', '.form-type-managed-file')).each(function() {
        // Accessiway dice: "La label è stata associata ad un pulsante, sovrascrivendone il nome, Togliere for="" dalla label".
        $(this).find('> label').removeAttr('for');
      });
    }
  };

  Drupal.behaviors.pperThemeA11yBr = {
    attach: function(context) {
      $(once('pper-theme-a11y-br', 'br', context)).attr('aria-hidden', 'true');
      $(once('pper-theme-a11y-br', '[data-webform-help]', context)).each(function() {
        $(this).attr('data-webform-help', function() {
          return $(this).attr('data-webform-help').replaceAll('<br ', '<br aria-hidden="true" ');
        });
      });
    },
  };

  Drupal.behaviors.pperThemeA11yMobileNavbar = {
    attach: function(context) {
      $(once('pper-theme-a11y-mobile-navbar', '.custom-navbar-toggler', context)).each(function() {
        var $target = $($(this).attr('data-target'));
        var $closeButton = $target.find('.close-div button');

        var check = function() {
          setTimeout(function() {
            if ($target.is('.expanded')) {
              focusTrap.trap($target);

              $('a', $target).off('blur');
              $target.find('button, a').eq(0).focus();
            }
            else {
              focusTrap.release();
            }
          }, 350);
        };

        $(this).click(check);
        $closeButton.click(check);
      });
    }
  };

  Drupal.behaviors.pperThemeA11yAjaxViewsSetAlertElement = {
    attach: function(context) {
      $(once('pper-theme-a11y-views-set-alert-element', '.view[is-ajax]')).each(function() {
        $('.set-role-alert, .view-empty', this).eq(0)
        .attr('role', 'alert')
        .attr('tabindex', '0')
        .focus();
      });
    }
  };

  Drupal.behaviors.pperThemeA11yFixDuplicateIDs = {
    ids: {},
    attach: function(context) {
      var _this = this;

      $(once('pper-theme-a11y-fix-duplicate-ids', '[id]')).each(function() {
        if (_this.ids[this.id] !== undefined && _this.ids[this.id] >= 1) {
          $(this).attr('id', this.id + '--' + _this.ids[this.id]);
        }

        if (_this.ids[this.id] === undefined) {
          _this.ids[this.id] = 0;
        }

        _this.ids[this.id]++;
      });
    },
    detach: function(context) {
      var _this = this;

      $('[id]', context).each(function() {
        if (_this.ids[this.id]) {
          --_this.ids[this.id];

          if (!_this.ids[this.id]) {
            delete _this.ids[this.id];
          }
        }
      });
    }
  };

  Drupal.behaviors.pperThemeRatingWithComment = {
    attach: function(context) {
      $(once('pper-theme-rating-with-comment-reset', '.vote-form', context)).each(function() {
        $('textarea', this).val('');
      });

      $(once('pper-theme-rating-with-comment', '.vote-form.comment-required')).each(function() {
        $('#vote-comment-modal').remove();

        var $modal = $('<div class="modal fade" id="vote-comment-modal" role="dialog" aria-labelledby="vote-comment-modal-title">' +
          '<div class="modal-dialog">' +
            '<form class="modal-content">' +
              '<div class="modal-header">' +
                '<h3 class="modal-title" id="vote-comment-modal-title">Lascia un commento</h3>' +
                '<button type="button" class="modal-close close" data-dismiss="modal" aria-label="Chiudi">' +
                  '<svg aria-hidden="true" class="icon" role="img">' +
                    '<use xlink:href="' + drupalSettings.path.baseUrl + 'themes/custom/portaledellafamiglia/dist/vendors/bootstrap-italia/svg/sprite.svg#it-close-big"></use>' +
                  '</svg>' +
                '</button>' +
              '</div>' +
              '<div class="modal-body">' +
                '<p class="mb-4">Per valutazioni negative, chiediamo un breve commento.<br /> Ci sarà utile per capire meglio la tua esperienza.</p>' +
                '<label for="vote-comment">Commento</label>' +
                '<textarea id="vote-comment" name="vote-comment" rows="10" required oninput="this.setCustomValidity(\'\')" oninvalid="this.setCustomValidity(\'E\\\' necessario fornire un commento per proseguire.\')"></textarea>' +
              '</div>' +
              '<div class="modal-footer">' +
                '<button type="button" style="background: transparent; border: none" data-dismiss="modal">Annulla</button>' +
                '<button type="submit" class="cta">Invia valutazione</button>' +
              '</div>' +
            '</form>' +
          '</div>' +
        '</div>');

        $(document.body).append($modal);

        $modal.on('shown.bs.modal', function() {
          $('textarea', this).focus();
        });

        $modal.modal('show');

        $(document.body).on('submit', '#vote-comment-modal form', function(ev) {
          ev.preventDefault();

          var $modal = $(ev.target);
          var comment = $.trim($('textarea', $modal).val());

          if (!comment) {
            return;
          }

          $('.br-widget:not(.br-readonly)').each(function() {
            var $form = $(this).closest('form');
            var rating = $('select', $form).val();
            $('textarea', $form).val(comment);
            $('[type="submit"]', $modal).text('In lavorazione...').prop('disabled', true);
            $('a[data-rating-value="' + rating + '"]', this).click();
          });
        });
      });

      $(once('pper-theme-rating-with-comment', '.vote-form.comment-received')).each(function() {
        $('#vote-comment-modal').modal('hide');
      });
    }
  };

  Drupal.behaviors.pperThemeSelects = {
    attach: function(context) {
      $(once('pper-theme-selects', 'select:not([data-vote-value]', context)).each(function() {
        $(this).each(function() {
          var $label = $(this).closest('.form-item').find('> label');
          var $select2;

          $label.attr('id',  function() {
            return $(this).attr('for') + '-label';
          });

          $(this).select2({
            minimumResultsForSearch: Infinity,
            templateResult: function(state) {
              var checkIcon = '<svg class="check-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>';
              var indentIcon1 = '<svg class="indent-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">\n' +
                '  <path d="M6 3v18" />  <!-- Linea verticale -->\n' +
                '  <path d="M6 12h8" />  <!-- Linea orizzontale per la connessione -->\n' +
                '</svg>';
              var indentIcon2 = '<svg class="indent-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">\n' +
                '  <path d="M6 3v8h8"></path>\n' +
                '</svg>';
              var text = state.text;
              text = text.replace('├', indentIcon1); // @see pf_core_form_views_exposed_form_alter().
              text = text.replace('└', indentIcon2); // @see pf_core_form_views_exposed_form_alter().
              return $('<span>' + checkIcon + text + '</span>');
            }
          });

          $select2 = $(this).next('.select2');

          $select2.find('.select2-selection')
            .attr('aria-haspopup', 'listbox')
            .attr('aria-labelledby', $label.attr('id'));

          $select2.find('.select2-search').remove();

          $(this).on('change', drawSelection);
          drawSelection.call(this);
        });

        function drawSelection() {
          if (!this.multiple) {
            return;
          }

          var selection = $(this).select2('data');
          var $select2 = $(this).next('.select2');
          var $button = $('<span class="custom-selection">Selezionati: ' + selection.length + '</button>');
          var labels = [];

          selection.forEach(function(item) {
            labels.push(item.text);
          });

          $button.attr('title', labels.join(', '));

          $select2.find('.custom-selection').remove();
          $select2.find('.select2-selection__rendered').after($button);

          // Non c'è un "postInit" hook, perciò cambia il tabindex "un po' più tardi".
          setTimeout(function() {
            $select2.find('.select2-selection').attr('tabindex', '0');
          }, 100);
        }
      });
    },
    detach: function(context) {
      if ($(context).is('.views-exposed-form ') || $(context).is('.webform-submission-form')) {
        // Caso: siamo in una vista ajax e stiamo facendo il detach prima di fare la request.
        // Se facciamo il detach ora select2 verrà sostituita da una select nativa e l'effetto anti-estetico.
        // Aspettiamo di fare il detach prima che venga incollato il nuovo html (in quel caso "context" sarà il div radice della vista).
        return;
      }

      $('select[data-select2-id]', context).select2('destroy');
    }
  };

  /**
   * @override
   *
   * Sovrascrittura del behavior "scrollTop" (Drupal core) che aggiunge i seguenti comportamenti:
   * - tiene conto dell'header fisso
   * - per viste "speciali", da mobile, scrolla dopo i filtri esposti per una migliore UX.
   */
  Drupal.AjaxCommands.prototype.scrollTop = function (response) {
    var EXTERNAL_OFFSET = 60 + 10 /*(Drupal.webform && Drupal.webform.scrollTopOffset) || 0*/;
    var $target = $(response.selector);

    if ($target.is('.view.mobile-view-scrolltop-behavior')) {
      if ($(window).width() < 992) {
        // @todo: aggiungi selettore mappa.
        $target = $target.find('.view-header, .view-content').filter(':visible').eq(0);
      }
      else if ($target.find('.view-desktop-scrolltop').length) {
        $target = $target.find('.view-desktop-scrolltop');
      }
    }

    var offset = $target.offset();
    // We can't guarantee that the scrollable object should be
    // the body, as the element could be embedded in something
    // more complex such as a modal popup. Recurse up the DOM
    // and scroll the first element that has a non-zero top.
    var scrollTarget = $target;
    while ($(scrollTarget).scrollTop() === 0 && $(scrollTarget).parent().length) {
      scrollTarget = $(scrollTarget).parent();
    }

    if (scrollTarget && scrollTarget.length > 0) {
      $(scrollTarget).animate({ scrollTop: offset.top - EXTERNAL_OFFSET }, 500);
    }
  };
})(jQuery);
